import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = { class: "text-xl font-bold" }
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = { class: "text-sm" }
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { class: "font-semibold" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "font-semibold" }
const _hoisted_13 = { class: "text-sm" }


import {
  computed,
  defineComponent,
  defineProps,
  onMounted,
  onUnmounted,
  ref,
  watch,
  defineEmits,
} from "vue";
import { currency } from "@/_helpers";
import dayjs from "dayjs";
import {

  CheckCircleTwoTone,
  CloseCircleTwoTone,
} from "@ant-design/icons-vue";

const __default__ = defineComponent({
  name: "LbrxSaleDrawer",
  components: {
    CheckCircleTwoTone,
    CloseCircleTwoTone,
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    open: { type: Boolean },
    sale: {},
    currencyCode: {},
    decimalPrecision: {}
  },
  emits: ["update:open"],
  setup(__props: any, { emit: __emit }) {



const props = __props;

const emit = __emit;

const open = ref(props.open);
watch(
  () => props.open,
  (newValue) => {
    open.value = newValue;
  }
);
watch(open, (newValue) => {
  emit("update:open", newValue);
});
const windowWidth = ref(window.innerWidth);

const modalWidth = computed(() => {
  // extra small devices
  if (windowWidth.value < 576) {
    return "100%";
  }
  // small devices
  else if (windowWidth.value >= 576 && windowWidth.value < 768) {
    return "60%";
  }
  // medium devices
  else if (windowWidth.value >= 768 && windowWidth.value < 992) {
    return 320;
  }
  // large devices
  else if (windowWidth.value >= 992 && windowWidth.value < 1200) {
    return 420;
  }
  // extra large devices
  else {
    return 600;
  }
});

const handleResize = () => {
  windowWidth.value = window.innerWidth;
};

const formatAmount = (
  amount: any,
  currencyCode: any,
  decimalPrecision: any
) => {
  return currency.formatAmount(amount, currencyCode, decimalPrecision);
};

const formatDate = (date: any) => {
  return dayjs(date).format("DD-MM-YYYY HH:mm");
};

onMounted(() => {
  window.addEventListener("resize", handleResize);
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    open: open.value,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((open).value = $event)),
    class: "custom-class",
    "root-class-name": "root-class-name",
    width: modalWidth.value
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t("Pos.CustomerSaleInfo")), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 12 }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("Pos.Date")) + " : ", 1),
              _createElementVNode("span", _hoisted_3, _toDisplayString(formatDate(_ctx.sale.created_at)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, { class: "mt-2" }, {
        default: _withCtx(() => [
          (_ctx.sale.order_number !== null)
            ? (_openBlock(), _createBlock(_component_a_col, {
                key: 0,
                span: 12
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("Pos.Order")) + " : ", 1),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.sale.order_number), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_col, { span: 12 }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("Pos.TotalPrice")) + " : ", 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(formatAmount(_ctx.sale.total, _ctx.currencyCode, _ctx.decimalPrecision)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, { class: "mt-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 12 }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("Pos.DiscountType")) + " : ", 1),
              (_ctx.sale.discount_type == 'percentage')
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _createVNode(_component_a_tag, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("Pos.Percentage")), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.sale.discount_type == 'amount')
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                    _createVNode(_component_a_tag, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("Pos.Amount")), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.sale.discount_type == 'fixed')
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    _createVNode(_component_a_tag, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("Pos.Fixed")), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { span: 12 }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("Pos.Discount")) + " : ", 1),
              _createElementVNode("span", _hoisted_13, _toDisplayString(formatAmount(_ctx.sale.discount_value, _ctx.currencyCode, _ctx.decimalPrecision)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, { class: "mt-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sale.items, (sales, id) => {
                return (_openBlock(), _createBlock(_component_a_descriptions, {
                  key: id,
                  bordered: "",
                  size: "small",
                  class: "mb-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_descriptions_item, {
                      label: _ctx.$t('Pos.Name'),
                      span: 3
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(sales.product.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]),
                    (sales.discount_value!=null)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_a_descriptions_item, {
                            label: _ctx.$t('Pos.Discount'),
                            span: 1
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(CheckCircleTwoTone), { "two-tone-color": "#52c41a" })
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_a_descriptions_item, {
                            label: _ctx.$t('Pos.Amount'),
                            span: 2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(formatAmount(sales.discount_value, _ctx.currencyCode, _ctx.decimalPrecision)), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"])
                        ], 64))
                      : (_openBlock(), _createBlock(_component_a_descriptions_item, {
                          key: 1,
                          label: _ctx.$t('Pos.Discount'),
                          span: 3
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CloseCircleTwoTone), { "two-tone-color": "#ff4d4f" })
                          ]),
                          _: 1
                        }, 8, ["label"])),
                    _createVNode(_component_a_descriptions_item, {
                      label: _ctx.$t('Pos.Quantity'),
                      span: 1
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(sales.quantity), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]),
                    _createVNode(_component_a_descriptions_item, {
                      label: _ctx.$t('Pos.Price'),
                      span: 2
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(formatAmount(
                sales.product.full_price,
                _ctx.currencyCode,
                _ctx.decimalPrecision
              )), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open", "width"]))
}
}

})